import React from 'react';
import { Platform } from 'react-native';
import { NextLink } from './next-link';
import { useLink } from './use-custom-link';
function LinkCore({ children, href, as, componentProps, Component, replace, experimental, ...props }) {
    if (Platform.OS === 'web') {
        return (React.createElement(NextLink, { ...props, replace: replace, href: href, as: as, passHref: true },
            React.createElement(Component, { ...componentProps }, children)));
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const linkTo = useLink({
        href,
        as,
        replace,
        experimental,
    });
    return (React.createElement(Component, { accessibilityRole: "link", ...componentProps, onPress: (e) => {
            componentProps?.onPress?.(e);
            linkTo.onPress(e);
        } }, children));
}
export { LinkCore };
//# sourceMappingURL=core.js.map